import React from "react";

import { AuthProvider } from "shared/contexts/Auth/AuthContext";
import { FavoritosProvider } from "shared/contexts/Auth/Favoritos/FavoritosContext";
import { NotificacoesProvider } from "shared/contexts/Auth/Notificacoes/NotificacoesContext";
import { ComprasProvider } from "shared/contexts/Auth/Compras/ComprasContext";
import { LojaProvider } from "shared/contexts/Loja/LojaContext";
import { CartProvider } from "shared/contexts/Cart/CartContext";
import { NotificationSound } from "shared/components/NotificationSound/NotificationSound";

interface Props {
  children: React.ReactNode;
}

export const AppProviders = ({ children }: Props) => {
  return (
    <AuthProvider>
      <LojaProvider>
        <FavoritosProvider>
          <NotificacoesProvider>
            <NotificationSound />

            <ComprasProvider>
              <CartProvider>
                {children}
              </CartProvider>
            </ComprasProvider>
          </NotificacoesProvider>
        </FavoritosProvider>
      </LojaProvider>
    </AuthProvider>
  );
};